export default __webpack_public_path__ + "media/images/admin/wallet-hover-96c1b914229d48837847709421344e6e.svg";